<template>
    <div @click.prevent="scrollToBookmark" class="bookmark-card mb-3">
        <div class="bookmark-name">
            {{ bookmark.title }}
        </div>
        <div class="bookmark-details">
            {{ formatType(bookmark.type) }}
        </div>
    </div>
</template>

<script>
const HUMAN_READABLE_TYPES = {
    'TicketNote': 'Note',
    'TicketForwardingLog': 'Email Forward',
    'TicketReply': 'Email Reply',
    'InboundEmail': 'Inbound Email',
    'InboundTextMessage': 'Inbound SMS',
    'TicketSmsLog': 'Outbound SMS',
    'TicketExpense': 'Expense'
};

export default {
    name: "Bookmark",
    props: {
        bookmark: {
            type: Object,
            required: true
        }
    },
    data() {
        return {}
    },
    created() {
    },
    computed: {
    },
    methods: {
        scrollToBookmark() {
            const leftColumn = document.getElementById('ticket-main-section-left-column');

            if (this.bookmark.type == 'TicketNote') {
                const note = document.getElementById(`ticket-note-${this.bookmark.id}`);

                if (note) {
                    leftColumn.scrollTo({
                        top: note.offsetTop - 150,
                        behavior: 'smooth'
                    });
                }
            } else if (this.bookmark.type == 'TicketForwardingLog') {
                const forwardingLog = document.getElementById(`ticket-forwarding-log-${this.bookmark.id}`);

                if (forwardingLog) {
                    leftColumn.scrollTo({
                        top: forwardingLog.offsetTop - 150,
                        behavior: 'smooth'
                    });
                }
            } else if (this.bookmark.type == 'TicketReply') {
                const reply = document.getElementById(`ticket-reply-${this.bookmark.id}`);

                if (reply) {
                    leftColumn.scrollTo({
                        top: reply.offsetTop - 150,
                        behavior: 'smooth'
                    });
                }
            } else if (this.bookmark.type == 'InboundEmail') {
                const inboundEmail = document.getElementById(`inbound-email-${this.bookmark.id}`);

                if (inboundEmail) {
                    leftColumn.scrollTo({
                        top: inboundEmail.offsetTop - 150,
                        behavior: 'smooth'
                    });
                }
            } else if (this.bookmark.type == 'InboundTextMessage') {
                const inboundTextMessage = document.getElementById(`inbound-text-message-${this.bookmark.id}`);

                if (inboundTextMessage) {
                    leftColumn.scrollTo({
                        top: inboundTextMessage.offsetTop - 150,
                        behavior: 'smooth'
                    });
                }
            } else if (this.bookmark.type == 'TicketSmsLog') {
                const smsLog = document.getElementById(`ticket-sms-log-${this.bookmark.id}`);

                if (smsLog) {
                    leftColumn.scrollTo({
                        top: smsLog.offsetTop - 150,
                        behavior: 'smooth'
                    });
                }
            } else if (this.bookmark.type == 'TicketExpense') {
                const expense = document.getElementById(`ticket-expense-${this.bookmark.id}`);

                if (expense) {
                    leftColumn.scrollTo({
                        top: expense.offsetTop - 150,
                        behavior: 'smooth'
                    });
                }
            }
        },

        formatType(type) {
            if (HUMAN_READABLE_TYPES[type]) {
                return HUMAN_READABLE_TYPES[type];
            }

            return type;
        }
    }
}
</script>

<style scoped lang="scss">
.bookmark-card {
    background: #fff;
    border-radius: 5px;
    padding: 15px;
    cursor: pointer;

    .bookmark-name {
        font-weight: 600;
        color: #2c5cc5;
    }

    .bookmark-details {
        padding-top: 5px;
        font-size: 12px;
    }
}
</style>